import React, { useEffect, useContext } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import CartContext from '../../middlewares/cart/CartContext'
import HomeNav from './_components/HomeNav'
import Products from './_components/Products'
import Sections from './_components/Sections'
import Footer from './_components/Footer'

interface CartCtx {
  deleteCart: () => void
}

const Home: React.FC = () => {
  const { t } = useTranslation()
  const { search } = useLocation()
  const { deleteCart } = useContext(CartContext) as CartCtx

  useEffect(() => {
    document.body.classList.add('page-home')
    return () => document.body.classList.remove('page-home')
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(search)
    if (params.get('deleteCart') === 'true') deleteCart()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <HomeNav />

      {/* Hero */}
      <main>
        <section className="relative overflow-hidden" style={{ borderBottom: '4px solid #000' }}>
          <div
            className="absolute inset-0 pointer-events-none"
            style={{ background: 'linear-gradient(135deg, #ffffff 0%, #f4fbf0 50%, #ffffff 100%)' }}
          />
          <div
            className="absolute pointer-events-none"
            style={{ top: '-8rem', right: '-8rem', width: 500, height: 500, borderRadius: '50%', backgroundColor: '#6eb446', opacity: 0.07 }}
          />
          <div
            className="absolute pointer-events-none"
            style={{ bottom: '-5rem', left: '-5rem', width: 300, height: 300, borderRadius: '50%', backgroundColor: '#6eb446', opacity: 0.07 }}
          />

          <div className="relative text-center" style={{ maxWidth: 900, margin: '0 auto', padding: '6rem 1.5rem' }}>
            <h1 style={{
              fontSize: 'clamp(2.5rem, 8vw, 5rem)',
              fontWeight: 900,
              letterSpacing: '-0.02em',
              lineHeight: 1.1,
              marginBottom: '1.5rem',
              color: '#1e293b',
            }}>
              Portal{' '}
              {process.env.REACT_APP_ENV === 'production' ? (
                <span style={{ color: '#6eb446' }}>Label Dictate</span>
              ) : (
                <span style={{ color: '#ef4444', textTransform: 'uppercase' }}>
                  {process.env.REACT_APP_ENV}
                </span>
              )}
            </h1>

            <p style={{
              fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
              color: '#475569',
              lineHeight: 1.75,
              maxWidth: 600,
              margin: '0 auto 2.5rem',
            }}>
              {t('home.text1')}
            </p>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', justifyContent: 'center' }}>
              <Link
                to="/auth/signup"
                style={{
                  display: 'inline-flex', alignItems: 'center',
                  padding: '0.875rem 2.5rem', borderRadius: '9999px',
                  backgroundColor: '#6eb446', color: '#fff',
                  fontWeight: 700, fontSize: '1.05rem',
                  textDecoration: 'none',
                  boxShadow: '0 8px 25px rgba(110,180,70,0.4)',
                  transition: 'filter 0.2s, transform 0.2s',
                }}
                onMouseEnter={e => { e.currentTarget.style.filter = 'brightness(1.08)'; e.currentTarget.style.transform = 'translateY(-2px)' }}
                onMouseLeave={e => { e.currentTarget.style.filter = 'brightness(1)'; e.currentTarget.style.transform = 'translateY(0)' }}
              >
                {t('header.signup')}
              </Link>

              <Link
                to="/auth/login"
                style={{
                  display: 'inline-flex', alignItems: 'center',
                  padding: '0.875rem 2.5rem', borderRadius: '9999px',
                  backgroundColor: 'transparent', color: '#1e293b',
                  fontWeight: 600, fontSize: '1.05rem',
                  textDecoration: 'none',
                  border: '2px solid #1e293b',
                  transition: 'background-color 0.2s, color 0.2s, transform 0.2s',
                }}
                onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#1e293b'; e.currentTarget.style.color = '#fff'; e.currentTarget.style.transform = 'translateY(-2px)' }}
                onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#1e293b'; e.currentTarget.style.transform = 'translateY(0)' }}
              >
                {t('header.login')}
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Products />
      <Sections />
      <Footer />
    </>
  )
}

export default Home
